import React, { PureComponent } from 'react';
// redux
import { connect } from 'react-redux';
import { getPage } from '../../redux/reducers/staticPages';
// utils
import { toastResponseErrors } from '../../utils/response';
// components
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import Preloader from '../../components/Preloader/Preloader';

class About extends PureComponent {
  componentDidMount() {
    const { getPage, about_us } = this.props;
    !about_us && getPage('about_us').catch(toastResponseErrors);
  }

  render() {
    const { isLoading, about_us } = this.props;

    return (
      <PageWrapper style={{ maxWidth: '900px' }}>
        <Preloader isActive={isLoading} />
        {about_us && (
          <div>
            <h1 style={{ textAlign: 'center' }}>{about_us.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: about_us.content }} />
          </div>
        )}
      </PageWrapper>
    );
  }
}

export default connect(
  state => ({
    about_us: state.staticPages.about_us,
    isLoading: state.staticPages.isLoading
  }),
  { getPage }
)(About);



// WEBPACK FOOTER //
// ./src/containers/About/About.jsx